import { createSelector } from "reselect";

const selectAssets = (state) => state.assets;

export const selectDevices = createSelector(
  [selectAssets],
  (assets) => assets.devices
);

export const selectIsDevicesFetching = createSelector(
  [selectAssets],
  (assets) => assets.isFetching
);
export const selectIsDevicesLoaded = createSelector(
  [selectAssets],
  (assets) => !!assets.devices
);
